import { render, staticRenderFns } from "./PastasAluno.vue?vue&type=template&id=774dafa4&scoped=true&"
import script from "./PastasAluno.vue?vue&type=script&lang=js&"
export * from "./PastasAluno.vue?vue&type=script&lang=js&"
import style0 from "./PastasAluno.vue?vue&type=style&index=0&id=774dafa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774dafa4",
  null
  
)

export default component.exports